import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VapourLanding from "./components/VapourLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VapourLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;